import React from 'react';
import classNames from 'classnames';
import { Tag as AntDTag, TagProps as AntDTagProps } from 'antd';

import './index.less';

type TagColors = 'default' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error';

interface Props extends Omit<AntDTagProps, 'color'> {
  color?: TagColors;
  disabled?: boolean;
  variant?: 'tertiary' | 'contained';
  size?: 'small' | 'middle' | 'large';
}

export type { Props as TagProps };

export default function Tag({
  icon,
  disabled = false,
  color = 'default',
  variant = 'tertiary',
  size = 'middle',
  className = '',
  ...props
}: Props) {
  return (
    <AntDTag
      icon={icon}
      className={classNames(
        `sl-tag tw-border-none sl-tag-${variant} sl-tag-${color} tw-mr-0`,
        {
          'tw-rounded-[4px]': size !== 'large',
          'tw-px-2': size === 'small',
          'tw-px-2 tw-py-1': size === 'middle',
          'tw-rounded-[8px] tw-py-2 tw-px-3 tw-font-medium': size === 'large',
          // tertiary
          'tw-bg-primary-100 tw-text-primary-600':
            color === 'primary' && variant === 'tertiary' && !disabled,
          'tw-bg-secondary-100 tw-text-secondary-600 ':
            color === 'secondary' && variant === 'tertiary' && !disabled,
          'tw-bg-success-100 tw-text-success-600 ':
            color === 'success' && variant === 'tertiary' && !disabled,
          'tw-bg-info-100 tw-text-info-600':
            color === 'info' && variant === 'tertiary' && !disabled,
          'tw-bg-warning-100 tw-text-warning-600':
            color === 'warning' && variant === 'tertiary' && !disabled,
          'tw-bg-error-100 tw-text-error-600':
            color === 'error' && variant === 'tertiary' && !disabled,
          'tw-bg-gray-100 tw-text-gray-600':
            (disabled || color === 'default') && variant === 'tertiary',
          // contained
          'tw-bg-primary-600 tw-text-primary-100':
            !disabled && color === 'primary' && variant === 'contained',
          'tw-bg-secondary-600 tw-text-secondary-100':
            !disabled && color === 'secondary' && variant === 'contained',
          'tw-bg-success-600 tw-text-success-100':
            !disabled && color === 'success' && variant === 'contained',
          'tw-bg-info-600 tw-text-info-100':
            !disabled && color === 'info' && variant === 'contained',
          'tw-bg-warning-600 tw-text-warning-100':
            !disabled && color === 'warning' && variant === 'contained',
          'tw-bg-error-600 tw-text-error-100':
            !disabled && color === 'error' && variant === 'contained',
          'tw-bg-gray-600 tw-text-gray-100':
            (disabled || color === 'default') && variant === 'contained',
        },
        className
      )}
      {...props}
    />
  );
}
